module.exports = __webpack_public_path__ + "img/bg-induce-m-03.ff2d5aad.png";